import { React, PT } from '@gasbuddy/react';
import { Grid, Popup, Button } from 'semantic-ui-react';

export const DeleteButton = ({ popupPosition, tooltip, confirm, deleter }) => {
  const listItem = (
    <Popup
      trigger={(
        <Button
          negative
          compact
          circular
          size="tiny"
          icon="delete"
          data-tooltip={tooltip}
          data-position={popupPosition}
        />
)}
      content={(
        <Grid columns={16} textAlign="center">
          <Grid.Row>
            <Grid.Column width={16}>
              {confirm}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                positive
                content="Confirm Delete"
                onClick={deleter}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
)}
      on="click"
      position={popupPosition}
    />
  );
  return listItem;
};

DeleteButton.defaultProps = {
  popupPosition: 'bottom left',
  tooltip: 'Delete this item',
  confirm: 'Are you sure?',
};

DeleteButton.propTypes = {
  popupPosition: PT.string,
  tooltip: PT.string,
  confirm: PT.string,
  deleter: PT.func.isRequired,
};
